// import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
// const Preloader = () => {
//   // const loading = useSelector(state => {
//   //     // Check if state.loading exists and is an object before calling Object.values
//   //     const loadingState = state.loading || {};
//   //     return Object.values(loadingState).some(status => status); // Check if any request is loading
//   // });

const Preloader = () => {
  let [active, setActive] = useState(true);
  useEffect(() => {
    setTimeout(function () {
      setActive(false);
    }, 1000);
  }, []);

  //   return (
  //     <>
  //       {loading && (
  //         <div className="preloader">
  //           <img src="/assets/images/icon/loader.gif" alt="Loading..." />
  //         </div>
  //       )}
  //     </>
  //   );
  // };
  return (
    <>
      {active ? (
        <div className="preloader">
          <img src="assets/images/icon/preloader.gif" alt="" />
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};
export default Preloader;
